import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Delete = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2898 5.71576H10.7898H5.21579H4.71579H4.26892L4.97784 12.6277C5.004 12.8828 5.21884 13.0767 5.47523 13.0767H10.5302C10.7865 13.0767 11.0014 12.8828 11.0275 12.6277L11.7365 5.71576H11.2898ZM11.2898 3.42877V4.71576H12.2904H13.5767C13.8528 4.71576 14.0767 4.93962 14.0767 5.21576C14.0767 5.4919 13.8528 5.71576 13.5767 5.71576H12.7417L12.0223 12.7298C11.9438 13.4949 11.2993 14.0767 10.5302 14.0767H5.47523C4.70606 14.0767 4.06154 13.4949 3.98306 12.7298L3.26367 5.71576H2.42871C2.15257 5.71576 1.92871 5.4919 1.92871 5.21576C1.92871 4.93962 2.15257 4.71576 2.42871 4.71576H3.71501H4.71579V3.42877C4.71579 2.60034 5.38736 1.92877 6.21579 1.92877H9.78977C10.6182 1.92877 11.2898 2.60035 11.2898 3.42877ZM5.71579 4.71576V3.42877C5.71579 3.15263 5.93964 2.92877 6.21579 2.92877H9.78977C10.0659 2.92877 10.2898 3.15263 10.2898 3.42877V4.71576H5.71579Z"
      />
    </svg>
  )
})

export default Delete
